// Server only flag in case other RSC compatible exports are added here later
import 'server-only';

export * from './query/prefetch';
